module.exports = __webpack_public_path__ + "img/globe-europe.dfb91090.svg";